/* 
0-> Name: shared Javascript
0-> Use: AllLayout
0-> Author: Tamaki,Takayuki
0-> Version: 1.0
0-> Update: 2022.3
*/
$.fn.extend({
	fadeOn : function(b, a) {
		if (siteDirection.fx.opacity) {
			return $(this).fadeIn(b, a);
		}
		let c = $(this).css('display', 'block');
		typeof a == "function" && a.call();
		return c;
	},
	fadeOff : function(b, a) {
		if (siteDirection.fx.opacity) {
			return $(this).fadeOut(b, a);
		}
		let c = $(this).css('display', 'none');
		typeof a == "function" && a.call();
		return c;
	},
	opacity : function(a) {
		let b = $(this).css('opacity', a);
		return b;
	}
});
const siteDirection = {
    fx:{
        opacity:!0,
        anims: !0
    },
	_uaOS : function() {
		if (navigator.userAgent.indexOf('Win') != -1) {
			return 'win';
		} else if (navigator.userAgent.indexOf('Mac') != -1) {
			return 'mac';
		} else if (navigator.userAgent.indexOf('Lin') != -1) {
			return 'lin';
		} else {
			return 'others';
		}
	},
	_uaBR : function() {
		return {
			ltIE6 : typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
			ltIE7 : typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
			ltIE8 : typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
			ltIE9 : document.uniqueID && !window.matchMedia,
			gtIE10 : document.uniqueID && document.documentMode >= 10,
			edg: window.navigator.userAgent.toLowerCase().indexOf('edg'),
			edge: window.navigator.userAgent.toLowerCase().indexOf('edge'),
			Trident : document.uniqueID,
			Gecko : 'MozAppearance' in document.documentElement.style,
			Presto : window.opera,
			Blink : window.chrome,
			Webkit : !window.chrome && 'WebkitAppearance' in document.documentElement.style,
			Touch : typeof document.ontouchstart != "undefined",
			Mobile : typeof window.orientation != "undefined",
			Pointer : window.navigator.pointerEnabled,
			MSPoniter : window.navigator.msPointerEnabled
		}
	},
	_ua : function(user) {
		return {
			Tablet : (user.indexOf("windows") != -1 && user.indexOf("touch") != -1) || user.indexOf("ipad") != -1 || (user.indexOf("android") != -1 && user.indexOf("mobile") == -1) || (user.indexOf("firefox") != -1 && user.indexOf("tablet") != -1) || user.indexOf("kindle") != -1 || user.indexOf("silk") != -1 || user.indexOf("playbook") != -1,
			Mobile : (user.indexOf("windows") != -1 && user.indexOf("phone") != -1) || user.indexOf("iphone") != -1 || user.indexOf("ipod") != -1 || (user.indexOf("android") != -1 && user.indexOf("mobile") != -1) || (user.indexOf("firefox") != -1 && user.indexOf("mobile") != -1) || user.indexOf("blackberry") != -1,
			Edge: (user.indexOf("edg") != -1 || user.indexOf("edge") != -1)
		}
	}(window.navigator.userAgent.toLowerCase()),
	init : function() {
		const $b = $('a[href*="#"],area[href*="#"],.c-gotoTop'),
			$c = $('.js-menu'),
		    $d = $('.js-btn'),
			$e = $('.js-toggle'),
			$f = $('.l-menu__itemParent'),
			$g = $('.l-menuInner__body'),
			hrefPath = location.pathname,
			currentWidth = window.innerWidth;
		let initial_height;
		let $win_width = $(window).width();
		if(siteDirection._ua.Edge){
			$('.l-fullBody').addClass('ua_edge');
		}

		$b.on('click', function() {
			let go_target = ($(this).hasClass('c-gotoTop')) ? $('body') : $(this.hash);
			go_target = go_target.length && go_target;
			if($d.hasClass('is-on')){
				$c.slideToggle(300);
				$d.removeClass('is-on');
				$('#menuBG').fadeOff(500,function(){
					$(this).remove();
				});
			}
			if (go_target.length) {
				let speed = 470,
				    slpos = (siteDirection._ua.Mobile || siteDirection._ua.Tablet) ? 100:80;
				let targetOffset = go_target.offset().top - slpos;
				$('html,body').stop(true,false).animate({
					scrollTop : targetOffset
				}, speed, 'easeOutQuint');
				return false;
			}
		});
		if(siteDirection._ua.Mobile || siteDirection._ua.Tablet){
		$(function(){
			  if(location.hash !== ""){
				  $('body,html').scrollTop(0);
				  setTimeout(function(){
					let target = $(location.hash);
					let position = target.offset().top - 75;
					$("body,html").stop().animate({
						scrollTop: position
					}, 350);
				  },0);
			  }
		});
		}
		$(window).scroll(function() {
			if ($(this).scrollTop() < 100) {
				$('.c-gotoTop').fadeOut();
				$('.l-header__innerBody').removeClass('is-move');
			} else {
				if ($('.c-gotoTop').is(':hidden')) {
					$('.c-gotoTop').fadeIn(530);
				}
				$('.l-header__innerBody').addClass('is-move');
			}
		});
		$d.on('click', function() {
			if (!$(this).hasClass('is-open')) {
				$c.slideToggle(300);
				$(this).addClass('is-open');
			} else {
				$c.slideToggle(300);
				$(this).removeClass('is-open');
			}
		});
		$c.find('.l-menu__item--h a').on('click',function(){
			$c.slideToggle(300);
			$d.removeClass('is-open');
		});
		if(!$('.p-toggle__body').hasClass('is-close')){
			initial_height = $('.p-toggle__body').outerHeight();
			$('.p-toggle__body,.p-toggle__button').addClass('is-close');
		}
		$(window).resize(function() {
			$win_width = $(window).width();
			if($win_width <736){
				initial_height = 2360;
			}

		});
		$e.on('click',function(){
			if($('.p-toggle__body').hasClass('is-close')){
				$('.p-toggle__body').animate({'height':initial_height},{duration:570,easing:'easeOutQuint',complete:function(){
					$(this).removeClass('is-close');
					$e.children('button').text('閉じる');
					$e.removeClass('is-close');
				}});
			} else if(!$('.p-toggle__body').hasClass('is-close')){
				$('.p-toggle__body').animate({'height':400,'overflow':'hidden'},{duration:370,easing:'linear',complete:function(){
					$(this).addClass('is-close');
					$e.addClass('is-close');
					$e.children('button').text('続きを読む');
				}});
			}
		});
		
	}
};
$(siteDirection.init);